export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SIDEBAR_TOGGLE = "SIDEBAR_TOGGLE";
export const LOADING = "LOADING";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
